import request from './request'
//import MD5 from './md5'
//import storage from "./storage";
import axios from 'axios';

let URL = 'http://dtlscan.bfbox.org'; 
	
// export function md5Data(oldData) {
// 		var data = JSON.parse(JSON.stringify(oldData || {})) //保存原始数据
// 		data = data || {};
// 		data.app_key = app_key;
// 		data.timestamp = new Date().toUTCString();
// 		var keys = [];
// 		for(var k in data) {
// 			if(data[k] === 0 || data[k] === false || data[k]) {
// 				keys.push(k);
// 			} else {
// 				delete data[k];
// 			}
// 		}

// 		keys = keys.sort();
// 		var signStr = '';
// 		for(var i = 0; i < keys.length; i++) {
// 			signStr += keys[i].toLowerCase() + data[keys[i]];
// 		} 
// 		data.sign= MD5.md5(signStr + appsecret);
// 		return data;
// }
export function getDomain(){
		return URL.replace("api","");
	} 
export function LogI(msg){
	console.log("I:"+ msg);//JSON.stringify(users) 
}
// 
export function getToken(){
	let users = storage.getJson("users");
	//console.log("getToken(users)="+ JSON.stringify(users)) ;
	if(users != null){
		return  users.userkey ;
	}
	else{
	   return "";
	}
}

export function getBlock(pageindex) {
	//var ptoken = getToken();  
	 var params ={"pageindex":pageindex}; 
	 return new Promise((resolve, reject) => {
	     request.get(URL + '/api/v1/Block/list',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res)
	     }).catch(err=>{
	 		reject(err)
	     });
	 });
}

export function getBlockTrans(pageindex,address) {	 
	 //console.log("getNewBlockTrans().URL="+ URL) ;
	 var params ={"pageindex":pageindex,"address":address};
	 return new Promise((resolve, reject) => {
	     request.get(URL + '/api/v1/Block/transaction',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res)
	     }).catch(err=>{
	 		reject(err)
	     });
	 });
}

export function getBlockBurns(pageindex,address) {	 
	//console.log("getNewBlockTrans().URL="+ URL) ;
	var params ={"pageindex":pageindex,"address":address};
	return new Promise((resolve, reject) => {
	     request.get(URL + '/api/v1/Block/burn',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res)
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

export function getBlockAddress(pageindex,address) {
	//console.log("getNewBlockTrans().URL="+ URL) ;
	var params ={"pageindex":pageindex,"address":address};
	return new Promise((resolve, reject) => {
	     request.get(URL + '/api/v1/Block/address',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res)
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

// export function getAssets(pageindex,paddress,psignature) {
// 	//console.log("getNewBlockTrans().URL="+ URL) ;
// 	var params ={"pageindex":pageindex,"address":paddress,"sign":psignature};
// 	return new Promise((resolve, reject) => {
// 	     request.get(URL + '/api/v1/Asset/list',params).then(res=>{
// 	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
// 	 		resolve(res)
// 	     }).catch(err=>{
// 	 		reject(err)
// 	     });
// 	});
// }

export function getAssets(pfromAddress,pconAddress,ptimestamp,psignature) {
	
	var params ={"id":128,"method":"bnt_assets","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
	//console.log("getAssets().params=",params);
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}
export function getAsset(pfromAddress,pconAddress,ptimestamp,psignature) {
	
	var params ={"id":128,"method":"bnt_asset","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
	//console.log("getAssets().params=",params);
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}
  
export function getAssetBalance(pfromAddress,pconAddress,ptimestamp,psignature) {
	 var params ={"id":128,"method":"bnt_balance","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

export function getAssetFrozen(pfromAddress,pconAddress,ptimestamp,psignature) {
	//console.log("getNewBlockTrans().URL="+ URL) ; 
	var params ={"id":128,"method":"bnt_frozen","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
	 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

export function getAssetFreed(pfromAddress,pconAddress,ptimestamp,psignature) {
	//console.log("getNewBlockTrans().URL="+ URL) ; 
	var params ={"id":128,"method":"bnt_freed","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
	
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

 export function getAssetAddressDeposit(pfromAddress,pconAddress,ptimestamp,psignature) {
 	//console.log("getNewBlockTrans().URL="+ URL) ; 
 	var params ={"id":128,"method":"bnt_addressdeposit","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature};
 	
 	return new Promise((resolve, reject) => {
 	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
 	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
 	 		resolve(res.result);
 	     }).catch(err=>{
 	 		reject(err)
 	     });
 	});
 }
 
//转账
export function postAssetTransaction(pfromAddress,pconAddress,ptoAddress,pamount,ptimestamp,psignature) {
	//console.log("getNewBlockTrans().URL="+ URL) ;
	//
	var params ={"id":1288,"method":"bnt_transaction","params":[pfromAddress,pconAddress,ptoAddress,pamount,ptimestamp],"sign":psignature}; 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

//质押
export function postAssetPledge(pfromAddress,pconAddress,pamount,ptimestamp,psignature) {
	 
	var params ={"id":128,"method":"bnt_pledge","params":[pfromAddress,pconAddress,pamount,ptimestamp],"sign":psignature}; 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}
 
//加速
export function postAssetAccelerate(pfromAddress,pconAddress,pamount,ptimestamp,psignature) {
	var params ={"id":128,"method":"bnt_accelerate","params":[pfromAddress,pconAddress,pamount,ptimestamp],"sign":psignature}; 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}

//减速
export function postAssetDecelerate(pfromAddress,pconAddress,pamount,ptimestamp,psignature) {
	var params ={"id":128,"method":"bnt_decelerate","params":[pfromAddress,pconAddress,pamount,ptimestamp],"sign":psignature}; 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}
 
//团队
export function getTeams(pfromAddress,pconAddress,ptimestamp,psignature) {
	var params ={"id":128,"method":"bnt_team","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature}; 
	return new Promise((resolve, reject) => {
	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
	 		resolve(res.result);
	     }).catch(err=>{
	 		reject(err)
	     });
	});
}
 
 //recodes
 export function getRecods(pfromAddress,pconAddress,pageIndex,ptimestamp,psignature) {
 	var params ={"id":128,"method":"bnt_records","params":[pfromAddress,pconAddress,pageIndex,ptimestamp],"sign":psignature}; 
 	return new Promise((resolve, reject) => {
 	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
 	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
 	 		resolve(res.result);
 	     }).catch(err=>{
 	 		reject(err)
 	     });
 	});
 } 
 
 export function getRecod(pfromAddress,pconAddress,ptimestamp,psignature) {
 	var params ={"id":128,"method":"bnt_record","params":[pfromAddress,pconAddress,ptimestamp],"sign":psignature}; 
 	return new Promise((resolve, reject) => {
 	     request.post(URL + '/api/v1/Rpc/provider',params).then(res=>{
 	 		//console.log("getNewBlock().res="+ JSON.stringify(res)) ;
 	 		resolve(res.result);
 	     }).catch(err=>{
 	 		reject(err)
 	     });
 	});
 } 
 
 
export function setDebug(pkey,pvalue) {
	//var ptoken = getToken();  
    return new Promise((resolve, reject) => {
        request.get(URL + '/api/v1/home/debug?key='+pkey+'&value='+pvalue).then(res=>{
			//console.log("setDebug().res="+ JSON.stringify(res)) ;
			resolve(res)
        }).catch(err=>{
			reject(err)
        });
    });
}

export function domain(){
	return request.domain();
}


//{"status":0,"message":"Success","request_id":"e7e4ae9b1562453b9c194d6eface1f8e","locations":[{"lat":34.179102,"lng":108.968394}]}
//获取当前位置的经纬度
//https://apis.map.qq.com/ws/location/v1/ip
//https://apis.map.qq.com/ws/location/v1/ip?ip=&key=
// export function getCarrierInfo() {
// 	return new Promise((resolve, reject) => {
// 	    uni.getLocation({
// 	        type: 'wgs84',
// 	        success: (location) => {
// 	            // 这里你需要使用外部API服务（如IP-API, ipinfo.io等）来查询位置信息
// 	            uni.request({
// 	                url: 'http://ip-api.com/json', // 使用IP查询API
// 	                method: 'GET',
// 	                success: (res) => {	
// 	                    resolve(res); // 返回运营商信息等
// 	                },
// 	                fail: () => {
// 	                    reject(new Error('网络请求失败'));
// 	                }
// 	            });
// 	        },
// 	        fail: () => {
// 	            reject(new Error('获取位置失败'));
// 	        }
// 	    });
// 	});
// } 
 